import { useState } from 'react';
import { useAppForm } from 'shared/UI/UIKit/Form';
import type { BellSchedule } from 'services/api';

interface UseBellScheduleViewProps {
  bellSchedule: BellSchedule;
}

export const useBellScheduleView = ({ bellSchedule }: UseBellScheduleViewProps) => {
  const [modalVisible, setModalVisible] = useState(false);

  const [form] = useAppForm<BellSchedule>();

  const showModal = () => {
    setModalVisible(true);
    form.setFieldsValue(bellSchedule);
  };

  const hideModal = () => {
    setModalVisible(false);
  };

  return {
    state: {
      modalVisible,
      form,
    },
    methods: {
      showModal,
      hideModal,
    },
  };
};
